import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de rapport de cholestérol";
const DESCRIPTION =
  "Calculatrice de rapport de cholestérol en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de rapport de cholestérol, calculatrice de rapport de cholestérol, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/cholesterol-ratio-calculator/";
function CholesterolRatioCalculator() {
  const [hdl, setHdl] = useState(0);
  const [ldl, setLdl] = useState(0);
  const [tg, setTg] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const hdlValue = parseFloat(hdl);
      const ldlValue = parseFloat(ldl);
      const tgValue = parseFloat(tg);
      const totalCholesterol = hdlValue + ldlValue + 0.2 * tgValue;
      const cholesterolHdlRatio = totalCholesterol / hdlValue;
      const ldlHdlRatio = ldlValue / hdlValue;
      let ldlHdlCategory = "";
      if (ldlHdlRatio < 2) {
        ldlHdlCategory = "Idéal";
      } else if (ldlHdlRatio < 5) {
        ldlHdlCategory = "Bon";
      } else {
        ldlHdlCategory = "Très élevé";
      }
      const tgHdlRatio = tgValue / hdlValue;
      let tgHdlCategory = "";
      if (tgHdlRatio <= 0.87) {
        tgHdlCategory = "Idéal";
      } else if (tgHdlRatio <= 2.62) {
        tgHdlCategory = "Élevé";
      } else {
        tgHdlCategory = "Très élevé";
      }
      setResult({
        totalCholesterol: totalCholesterol.toFixed(2),
        ldlHdlRatio: ldlHdlRatio.toFixed(2),
        ldlHdlCategory,
        tgHdlRatio: tgHdlRatio.toFixed(2),
        tgHdlCategory,
        cholesterolHdlRatio: cholesterolHdlRatio.toFixed(2),
      });
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Cette calculatrice vous aide à connaître votre rapport de cholestérol et votre santé cardiaque.</p>
                <p>
                  La compréhension de votre taux de cholestérol est la première étape vers un cœur sain. Cette calculatrice vous permet de comprendre ce que signifient vos résultats de test de cholestérol. En saisissant vos valeurs, vous obtiendrez une interprétation simplifiée du cholestérol total, LDL, HDL et TG. Utilisez ces informations pour prendre des décisions éclairées concernant votre santé.
                </p>
                <p>
                  Prenez soin de votre santé cardiaque ! Cette calculatrice vous aide à évaluer votre santé cardiaque en calculant différents rapports de cholestérol. En saisissant les valeurs de cholestérol total, LDL (mauvais cholestérol), HDL (bon cholestérol) et TG (triglycérides), vous aurez une idée de l'équilibre de votre taux de cholestérol.
                </p>
                <p>
                  <b>
                    Important : Cette calculatrice est un outil d'aide uniquement et ne doit pas être utilisée comme diagnostic médical. Si vous avez des préoccupations concernant votre santé, consultez votre médecin.
                  </b>
                </p>
                <p>
                  La calculatrice a été développée en se basant sur la{" "}
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2747394/"
                    rel="nofollow"
                  >
                    Bibliothèque de médecine internationale
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="hdl">
                        HDL - Lipoprotéine de haute densité (bon cholestérol)
                      </label>
                      <input
                        id="hdl"
                        type="number"
                        value={hdl}
                        onChange={(e) => setHdl(e.target.value)}
                        placeholder="Entrez le niveau HDL"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="ldl">
                        LDL - Lipoprotéine de basse densité (mauvais cholestérol)
                      </label>
                      <input
                        id="ldl"
                        type="number"
                        value={ldl}
                        onChange={(e) => setLdl(e.target.value)}
                        placeholder="Entrez le niveau LDL"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="tg">
                        TG - Triglycérides
                      </label>
                      <input
                        id="tg"
                        type="number"
                        value={tg}
                        onChange={(e) => setTg(e.target.value)}
                        placeholder="Entrez le niveau TG"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur : {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat :</h4>
                      <p className="text-white">
                        Cholestérol total : {result.totalCholesterol}
                      </p>
                      <p className="text-white">
                        Rapport Cholestérol / HDL est : {result.cholesterolHdlRatio}
                      </p>
                      <p className="text-white">
                        Rapport LDL/HDL est : {result.ldlHdlRatio} -{" "}
                        {result.ldlHdlCategory}
                      </p>
                      <p className="text-white">
                        Rapport TG/HDL est : {result.tgHdlRatio} -{" "}
                        {result.tgHdlCategory}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Plus de détails</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Rapports de cholestérol</h2>
                  </u>
                  <p>
                    Le cholestérol est une substance grasse nécessaire à diverses fonctions corporelles. Cependant, des niveaux élevés peuvent causer des problèmes de santé.
                  </p>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Comprendre les valeurs</h2>
                  </u>
                  <p>
                    Des niveaux bas de LDL et des niveaux élevés de HDL aident à réduire le risque de maladie cardiaque. Il est également important de suivre le rapport TG/HDL car c'est un indicateur de la santé cardiaque.
                  </p>
                  <p>
                    <b>Rapport HDL (bon cholestérol) :</b>
                  </p>
                  <ul>
                    <li>Pour les hommes : supérieur à 40 mg/dL</li>
                    <li>Pour les femmes : supérieur à 50 mg/dL</li>
                  </ul>
                  <p>
                    <b>Rapport LDL (mauvais cholestérol) :</b>
                  </p>
                  <ul>
                    <li>Niveau optimal : inférieur à 100 mg/dL</li>
                    <li>Niveau élevé : entre 130-159 mg/dL</li>
                    <li>Très élevé : supérieur à 160 mg/dL</li>
                  </ul>
                  <p>
                    <b>Rapport TG (triglycérides) :</b>
                  </p>
                  <ul>
                    <li>Niveau normal : inférieur à 150 mg/dL</li>
                    <li>Niveau élevé : entre 200-499 mg/dL</li>
                    <li>Très élevé : supérieur à 500 mg/dL</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Comment améliorer les rapports de cholestérol
                    </h2>
                  </u>
                  <p>
                    La consommation d'aliments riches en fibres, l'exercice régulier et l'évitement des graisses saturées peuvent vous aider à améliorer les rapports de cholestérol dans votre corps.
                  </p>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Alimentation et cholestérol</h3></div>
              <div className="info-section-body">
                <p>L'alimentation joue un rôle clé dans la gestion du cholestérol. Les graisses saturées (viandes grasses, beurre, fromages) et les graisses trans (produits industriels) font monter le LDL. À l'inverse, les acides gras insaturés (huile d'olive, poisson gras, avocats, noix) aident à augmenter le HDL. Les fibres solubles, présentes dans l'avoine, les légumineuses et les fruits, réduisent l'absorption du cholestérol dans l'intestin.</p>
                <ul>
                  <li><strong>À privilégier :</strong> poisson 2à/semaine, huile d'olive, fruits, légumes, légumineuses</li>
                  <li><strong>À limiter :</strong> charcuterie, fromages gras, viennoiseries, fritures</li>
                  <li><strong>Exercice :</strong> 30 minutes d'activité modérée par jour augmente le HDL de 5 à 10 %</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quand consulter un médecin ?</h3></div>
              <div className="info-section-body">
                <p>En France, un bilan lipidique (dosage du cholestérol total, LDL, HDL et triglycrides) se fait sur prescription médicale, à jeun depuis au moins 12 heures. Il est recommandé à partir de 40 ans chez l'homme et de 50 ans chez la femme (ou dès la ménopause), ou plus tôt en cas de facteurs de risque (antécédents familiaux, diabète, hypertension, tabagisme). Un traitement médicamenteux (statines) peut être prescrit si les mesures hygiéno-diététiques sont insuffisantes.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CholesterolRatioCalculator;
